import React from "react";
import useApi from "../useApi";
import TiposApiClient from "../../api/tipos";

export default function useTipos(categoria = null) {
  const [tipos, setTipos] = React.useState([]);

  const { request: getTipos, data: tiposResponse } = useApi(
    TiposApiClient.listTipos
  );

  //Busca tipos ao renderizar tela
  React.useLayoutEffect(() => {
    if (categoria) getTipos({ categoria: categoria });
  }, [categoria, getTipos]);

  //Define estado tipos ao receber tipos
  React.useEffect(() => {
    if (tiposResponse) setTipos(tiposResponse);
  }, [tiposResponse, setTipos]);

  return tipos;
}
